import { render, staticRenderFns } from "./WalletBalanceRecord.vue?vue&type=template&id=464cfbc4&scoped=true&"
import script from "./WalletBalanceRecord.vue?vue&type=script&lang=js&"
export * from "./WalletBalanceRecord.vue?vue&type=script&lang=js&"
import style0 from "./WalletBalanceRecord.vue?vue&type=style&index=0&id=464cfbc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464cfbc4",
  null
  
)

export default component.exports